"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateProgressReport = exports.ProgressReportSchema = exports.isProgressReportData = exports.ProgressReportDataSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
exports.ProgressReportDataSchema = zod_1.z.object({
    pronunciationPatterns: zod_1.z.number(),
    spellingPatterns: zod_1.z.number(),
    videosWatched: zod_1.z.number(),
    wordPairs: zod_1.z.number(),
});
exports.isProgressReportData = type_validation_helpers_1.getTypeValidationFunction(exports.ProgressReportDataSchema);
exports.ProgressReportSchema = zod_1.z.object({
    data: exports.ProgressReportDataSchema,
    reportedAt: zod_1.z.string(),
});
const validateProgressReport = (x) => exports.ProgressReportSchema.safeParse(x);
exports.validateProgressReport = validateProgressReport;
//# sourceMappingURL=progress_reports_types.js.map